import { UserApiEndpoints } from '@contracts';

export const USER_ENDPOINTS: UserApiEndpoints = {
  list: {
    path: 'users',
    domain: 'core',
    version: 'v1',
  },
  detail: {
    path: `users/`,
    domain: 'core',
    version: 'v1',
  },
  create: {
    path: 'users',
    domain: 'core',
    version: 'v1',
  },
  update: {
    path: `users/`,
    domain: 'core',
    version: 'v1',
  },
  delete: {
    path: `users/`,
    domain: 'core',
    version: 'v1',
  },
};
